import { NewsFeedItem } from "../../model/whats-new-model"

export const WhatsNewActionTypes = {
    API_ATTEMPT:   "@@whats-new/API_ATTEMPT",
    API_FAILURE:   "@@whats-new/API_FAILURE",
    SET_FEED:      "@@whats-new/SET_FEED",
    SET_OPEN:      "@@whats-new/SET_OPEN",
}

export interface WhatsNewState {
    readonly loading: boolean
    readonly error: Error | null
    readonly items: NewsFeedItem[]
    readonly isOpen: boolean
}
